import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e91d1fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap gap-x-8"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-x1"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = {
  key: 2,
  class: "discount-label o-text-caption"
}
const _hoisted_6 = {
  key: 3,
  class: "discount-label o-text-caption"
}
const _hoisted_7 = {
  key: 1,
  class: "flex gap-x1 mt-x1"
}
const _hoisted_8 = { class: "o-text-caption" }
const _hoisted_9 = { class: "o-text-caption" }
const _hoisted_10 = {
  key: 1,
  class: "o-text-caption"
}
const _hoisted_11 = {
  key: 1,
  class: "o-text-caption font-bold"
}
const _hoisted_12 = {
  key: 2,
  class: "o-text-caption text-dusty-grey text-left w-full"
}

import siteContextService from '@/b2c/shared/site-context.service';
import { BoliaMoney, ProductDiscountType, ProductPriceModel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { computed } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotPrice',
  props: {
    price: null,
    fromPrice: null,
    isOutlet: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    price: ProductPriceModel;
    fromPrice: BoliaMoney | undefined;
    isOutlet?: boolean,
}



const globalLabels = useGlobalLabels(GlobalLabels.product);

const showFromPrice = computed(() => {
    const hasFromPrice = !!props.fromPrice && !!props.fromPrice.rawAmount;
    const hasSalesPrice = !!props.price.salesPrice && !!props.price.salesPrice.rawAmount;
    const hasAdditionalVariants = hasFromPrice && props.fromPrice.rawAmount !== props.price.salesPrice.rawAmount;
    return hasFromPrice && hasSalesPrice && hasAdditionalVariants;
});

const hasMyBoliaBoostDiscount = computed(() => {
    return props.price.discount?.type === ProductDiscountType.MyBoliaBoost;
});

const hasCampaignDiscount = computed(() => {
    return props.price.discount?.type === ProductDiscountType.Campaign;
});

const showSalesPrice = computed(() => {
    return props.price.salesPrice && props.price.salesPrice.amount;
});

const hasDiscount = computed(() => !!props.price.discount);

const showListPrice = computed(() => {
    return !siteContextService.isBrandSite && (hasDiscount.value || props.isOutlet);
});

const showDiscountText = computed(() => {
    return hasDiscount.value && !siteContextService.isBrandSite;
});

const moreVariantsFromLabel = computed(() => {
    return dictionaryService.formatNamed(globalLabels.moreVariantsFrom, { price: props.fromPrice!.amount });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showFromPrice) || _unref(showSalesPrice))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(showFromPrice) || _unref(showSalesPrice))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_unref(showSalesPrice))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_unref(showListPrice))
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(["o-text-caption", {'font-bold': _unref(hasDiscount)}])
                          }, _toDisplayString(__props.price.salesPrice.amount), 3))
                        : _createCommentVNode("", true),
                      (__props.price.listPrice.amount && !_unref(hasMyBoliaBoostDiscount))
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: _normalizeClass(["o-text-caption", {'line-through': _unref(showListPrice)}])
                          }, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(`${_unref(globalLabels).previousListPrice}:`), 1),
                            _createTextVNode(" " + _toDisplayString(__props.price.listPrice.amount), 1)
                          ], 2))
                        : _createCommentVNode("", true),
                      (_unref(hasCampaignDiscount) && _unref(showDiscountText))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).discount, {discount: __props.price.discount.percentage})), 1))
                        : _createCommentVNode("", true),
                      (_unref(showDiscountText) && _unref(hasMyBoliaBoostDiscount))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).myBoliaDiscount, {discount: __props.price.discount.percentage})), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (__props.price.listPrice.amount && _unref(hasMyBoliaBoostDiscount))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(__props.price.listPrice.amount), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(globalLabels).nonMemberDiscountText), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(showFromPrice))
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(moreVariantsFromLabel)), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_unref(showSalesPrice))
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(globalLabels).notAvailable), 1))
      : _createCommentVNode("", true),
    (__props.price.ecoTaxPrice?.amount)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(globalLabels).ecoTaxIncluded) + " " + _toDisplayString(__props.price.ecoTaxPrice.amount), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})